/**
 * Dashboard router file
 *
 * @package    src/components
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly/dashboard
 */
import { lazy } from 'react';
import PersonIcon from '@material-ui/icons/Person'
import AccountIcon from '@material-ui/icons/AccountBox'
import ProductDesignIcon from '@material-ui/icons/ImportantDevices'
import WorkIcon from '@material-ui/icons/WorkOutline';
import GroupIcon from '@material-ui/icons/Group';
import PollTwoToneIcon from '@material-ui/icons/PollTwoTone';
import HomeIcon from '@material-ui/icons/Home';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import PageConstant from '../constants/PageConstant';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Notifications from '../legacy_components/UI_V2_Components/Notifications/Notifications';
import FinalizeResumeV2 from '../legacy_components/UI_V2_Components/FinalizeResume/FinalizeResumeV2';
import JobsApplied from '../legacy_components/UI_V2_Components/shared/JobsApplied/Jobs';



const Profile = lazy(() => import('../legacy_components/UI_V2_Components/profile/Profile'));
const ProfileV2 = lazy(() => import('../components/Profile/Layout'));
const Tests = lazy(() => import('../legacy_components/UI_V2_Components/tests/TestsAB'));
const Referral = lazy(() => import('../legacy_components/UI_V2_Components/Referral'));
const CodingChallengeAB = lazy(() => import('../legacy_components/UI_V2_Components/CodingChallenge/LCI_AB'));
const Home_AB = lazy(() => import('../legacy_components/UI_V2_Components/home/Home_AB'));
const SoftSkills = lazy(() => import('../legacy_components/UI_V2_Components/SoftSkills/SoftSkills'));
const FinalizeResumeAB = lazy(() => import('../legacy_components/UI_V2_Components/FinalizeResume/FinalizeResumeAB'));
const UserAccount = lazy(() => import('../containers/Dashboard/SettingsPageAB'));
const TuringCommunity = lazy(() => import('../legacy_components/UI_V2_Components/TuringCommunity/TuringCommunity'));
// import UserProfileV2 from '../legacy_components/components/public/UserProfile_v2/UserProfile_v2';

/**
 * Dashboard container array
 */
const dashboardRoutes = [
  /* legacy_components */
  {
    type: 'menuItem',
    path: '/dashboard/home',
    title: 'Home',
    navbarName: 'Welcome!',
    icon: 'home',
    mobileIcon: HomeIcon,
    component: Home_AB
  },
  {
    type: 'menuItem',
    title: 'Notifications',
    path: '/dashboard/notifications',
    className: 'menu-notification',
    navbarName: 'Notifications',
    icon: 'notifications',
    mobileIcon: NotificationsIcon,
    onClick: Notifications.onMenuClick,
    divider: true,
    Badge: Notifications.Badge
  },
  {
    type: 'menuItem',
    path: PageConstant.APPLIED_JOBS_PAGE,
    title: 'Jobs',
    navbarName: 'AppliedJobs',
    icon: 'work_outline',
    mobileIcon: WorkIcon,
    component: JobsApplied,
    hidden: true
  },
  {
    type: 'menuItem',
    path: '/dashboard/turing_test',
    title: 'Quizzes',
    navbarName: 'Tests',
    collapsed_icon: 'polltwotoneicon',
    mobileIcon: PollTwoToneIcon,
    component: Tests,
    passed: false,
    disabled: true
  },
  {
    type: 'menuItem',
    path: '/dashboard/coding_challenge',
    title: 'Challenges',
    navbarName: 'Coding Challenge',
    collapsed_icon: 'developer_board',
    mobileIcon: ProductDesignIcon,
    component: CodingChallengeAB,
    passed: false,
    disabled: true
  },
  {	
    type: 'menuItem',
    path: `${PageConstant.SOFT_SKILLS}`,	
    title: 'Soft Skills',	
    navbarName: 'Soft Skills',	
    icon: 'groups',	
    mobileIcon: GroupIcon,	
    component: SoftSkills,
    disabled: true,
    hidden: true
  },
  {
    type: 'menuItem',
    path: PageConstant.FINALIZE_RESUME,
    title: 'Profile',
    navbarName: 'Profile',
    collapsed_icon: 'person',
    mobileIcon: PersonIcon,
    component: FinalizeResumeV2, // the Old Profile component -> UserProfile
    passed: false
  },
  {
    path: PageConstant.DASHBOARD_PROFILE,
    title: 'Basic Info',
    navbarName: 'Basic Info',
    collapsed_icon: 'person',
    mobileIcon: PersonIcon,
    component: Profile, // the Old Profile component -> UserProfile
    passed: false
  },
  {
    path: PageConstant.REFERRAL,
    title: 'Refer & Win $250',
    navbarName: 'Refer & Win $250',
    icon: 'local_atm',
    mobileIcon: LocalAtmIcon,
    style: { color: '#66CC80' },
    component: Referral
  },
  {
    path: PageConstant.TURING_COMMUNITY,
    title: 'Turing Community',
    navbarName: 'Turing Community',
    icon: 'groups',
    mobileIcon: GroupIcon,
    component: TuringCommunity
  },
  {
    path: '/dashboard/account',
    title: 'Settings',
    navbarName: 'User Account',
    icon: 'account_box',
    mobileIcon: AccountIcon,
    component: UserAccount,
  },
  {
    path: PageConstant.NEW_PROFILE_PAGE,
    title: 'Profile V2',
    navbarName: 'Profile V2',
    icon: 'person',
    mobileIcon: PersonIcon,
    component: ProfileV2,
  }
]

export default dashboardRoutes
